import React from 'react';
import styled from 'styled-components'; 

export default function CampaignMainListTop({currTab, onSelect}) {
   

  return (
    <NavWrapper>
      {(currTab === 'joinable')?( <NavSelectedItem>참여모집</NavSelectedItem>):( <NavItem onClick={()=>{if(onSelect)onSelect('joinable')}}>참여모집</NavItem>)}
      {(currTab === 'progress')?( <NavSelectedItem>진행중</NavSelectedItem>):( <NavItem onClick={()=>{if(onSelect)onSelect('progress')}}>진행중</NavItem>)}
      {(currTab === 'complete')?( <NavSelectedItem>진행완료</NavSelectedItem>):( <NavItem onClick={()=>{if(onSelect)onSelect('complete')}}>진행완료</NavItem>)}
    </NavWrapper>
  );
} 

export const NavWrapper = styled.div``
export const NavItem = styled.div`
  cursor: pointer;
  display: inline-block;
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw*(14/375));
  color: #989898;
  padding : calc(100vw*(8/375)) calc(100vw*(13/375));
  border-radius: calc(100vw*(19/375));
` 

export const NavSelectedItem = styled(NavItem)`
  background: #121212;
  color : #ffffff;
` 